import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Label,
    Icon, Form, Dropdown, Table, Popup, Card, Placeholder, Divider, Tab, Loader
} from 'semantic-ui-react';
import download from 'downloadjs';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import ReactApexChart from 'react-apexcharts';

export default class SimpleStatisticTable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {
            tableHeader, questionList, tableRibbonLabel, buttonReport, buttonReportText, graphically, questionOptions, averageForQuestionnaire
        } = this.props;
        return (

            <div>
                {questionList.length ?
                    <Table celled selectable compact >
                        <Table.Header>
                            {tableHeader && <Table.Row >
                                <Table.HeaderCell colSpan={1 + 5 + 4 + 1 - 1}>
                                    <Label ribbon color="blue">{tableRibbonLabel} { localStorage.getItem('numberOfStudentsWhoRatedCourse')} </Label>
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={2} textAlign="center">
                                    {buttonReport && <Header style={IconHeader} textAlign="center">
                                        <Button
                                            icon="download"
                                            content={buttonReportText}
                                            // labelPosition="right"
                                            color="blue"
                                            size="small"
                                            style={FiltersOnStyle}
                                            onClick={this.printReport}
                                        >
                                        </Button>

                                    </Header>}

                                </Table.HeaderCell>
                            </Table.Row>}
                            <Table.Row>

                                <Table.HeaderCell >

                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={5}>
                                Sadržaj pitanja
                                </Table.HeaderCell>
                                { graphically &&
                                <Table.HeaderCell textAlign="center">
                                    Grafički prikaz
                                </Table.HeaderCell>}
                                { questionOptions.length ?
                                    questionOptions.map((text) => (<Table.HeaderCell textAlign="center" >
                                        { text}
                                    </Table.HeaderCell>)) : <Table.HeaderCell />
                                }
                                <Table.HeaderCell textAlign="center" >
                                Prosjek
                                </Table.HeaderCell>


                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {questionList.map((el, index) =>
                                (<Table.Row key={index}>
                                    <Table.Cell verticalAlign="middle" textAlign="center">
                                        {index + 1}.
                                    </Table.Cell>
                                    <Table.Cell colSpan={5} verticalAlign="middle" >
                                        {el.questionText}
                                    </Table.Cell>
                                    {graphically && <Table.Cell verticalAlign="middle" textAlign="center" width={1}>
                                        {/* <Icon bordered color="blue" name="chart bar" /> */}
                                        <Dropdown
                                            simple
                                            className="icon"
                                            icon="chart pie"
                                            bordered
                                            color="blue"
                                        >

                                            <Dropdown.Menu>

                                                <Dropdown.Item><Card fluid>
                                                    <Card.Content>

                                                        <div id="chart">
                                                            {/* <ReactApexChart options={this.state.options2} series={this.getDataForQuestion(index)} type="pie" width="400" height="400" /> */}
                                                        </div>
                                                    </Card.Content>
                                                </Card></Dropdown.Item>

                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Table.Cell>}
                                    { questionOptions.length ?
                                        el.answers.map((text) => (<Table.Cell verticalAlign="middle" textAlign="center">
                                            { text}
                                        </Table.Cell>)) : <Table.HeaderCell />
                                    }

                                    <Table.Cell verticalAlign="middle" textAlign="center" warning={parseFloat(el.averagePerQuestion).toFixed(2) >= 2 && parseFloat(el.averagePerQuestion).toFixed(2) <= 4} negative={parseFloat(el.averagePerQuestion).toFixed(2) < 2} positive={parseFloat(el.averagePerQuestion).toFixed(2) > 4}>
                                        {el.averagePerQuestion ? parseFloat(el.averagePerQuestion).toFixed(2) : 0}
                                    </Table.Cell>
                                </Table.Row>))}

                        </Table.Body>
                        <Table.Footer>
                            <Table.Row>

                                <Table.HeaderCell colSpan={1 + 5 + 1 + 4 + 1 - 1} verticalAlign="middle" textAlign="right"><h4>UKUPAN PROSJEK:</h4></Table.HeaderCell>
                                <Table.HeaderCell
                                    verticalAlign="middle"
                                    textAlign="center"
                                    warning={parseFloat(averageForQuestionnaire).toFixed(2) >= 2 && parseFloat(averageForQuestionnaire).toFixed(2) <= 4}
                                    positive={parseFloat(averageForQuestionnaire).toFixed(2) > 4}
                                    negative={parseFloat(averageForQuestionnaire).toFixed(2) < 2}
                                ><h4>{parseFloat(averageForQuestionnaire).toFixed(2) < 2 && <Icon color="red" name="attention" />}
                                        {parseFloat(averageForQuestionnaire).toFixed(2) > 4 && <Icon color="green" name="checkmark" />}
                                        {parseFloat(averageForQuestionnaire).toFixed(2)}</h4></Table.HeaderCell>
                            </Table.Row>

                        </Table.Footer>
                    </Table> : 'Nema pitanja.'}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/ProfessorPoll/SimpleStatisticTable.js